import {
  Checkbox,
  type CheckboxProps,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@material-ui/core";
import React from "react";
import HelperText from "./HelperText";

export interface CheckboxFieldProps extends CheckboxProps {
  helperText?: string;
  /**
   * Force the helper row not to be displayed.
   * This will suppress the any errors from being shown but will set the height of the component to be only
   * the height of the input; rather than including whitespace for the error/helper message to render in.
   */
  hideHelper?: boolean;
  error?: string;
  label?: string;
  dataTestId?: string;
}

const CheckboxField = React.forwardRef(
  (
    props: CheckboxFieldProps,
    ref: React.Ref<HTMLInputElement>,
  ): React.ReactElement => {
    const {
      color = "primary",
      helperText = null,
      hideHelper,
      name,
      label = null,
      error = undefined,
      onChange,
      onFocus,
      onBlur,
      required = false,
      checked,
      dataTestId = "",
      disabled,
    } = props;

    const checkboxProps: CheckboxProps = {
      name,
      color,
      onChange,
      onFocus,
      onBlur,
      required,
      checked,
      disabled,
    };

    return (
      <FormControl>
        <FormControlLabel
          inputRef={ref}
          control={<Checkbox {...checkboxProps} data-testid={dataTestId} />}
          label={label}
        />
        {hideHelper ? null : (
          <FormHelperText>
            <HelperText error={error}>{helperText}</HelperText>
          </FormHelperText>
        )}
      </FormControl>
    );
  },
);

export default CheckboxField;
